import { NavArrowButton } from '../../NavArrow'
import { useTabScrollButtonVisibility } from '../Tab.hooks'

import { TAB_SCROLL_BUTTON_PROPS } from './TabScrollButton.constants'

import * as styles from './TabScrollButton.module.css'

function TabScrollButton({
  buttonProps = TAB_SCROLL_BUTTON_PROPS,
  className = styles.TabScrollButton,
  direction,
  disabled,
  visible,
  onClick,
}) {
  const { handleMouseEnter, handleMouseLeave, isClosing, isHovered } =
    useTabScrollButtonVisibility()

  const shouldRender = visible || isHovered || isClosing

  return shouldRender ? (
    <div
      className={className}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <NavArrowButton
        {...buttonProps}
        direction={direction}
        disabled={disabled}
        onClick={onClick}
      />
    </div>
  ) : null
}

export default TabScrollButton
